import { render } from "./pk10.vue?vue&type=template&id=ac02ba28&scoped=true"
import script from "./pk10.vue?vue&type=script&lang=js"
export * from "./pk10.vue?vue&type=script&lang=js"

import "./pk10.vue?vue&type=style&index=0&id=ac02ba28&lang=scss&scoped=true"
import "./pk10.vue?vue&type=style&index=1&id=ac02ba28&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac02ba28"]])

export default __exports__